import { Stream } from '@engoo/realtime-protocol/stream';
import callStateReducer, { CallState } from 'app/models/rtc/callState/reducer';
import { tFunctionType } from 'app/services/localization';
import { LWWDocumentManager, IActionHandler } from 'app/services/rtc/sync/documentmanagers/lww';
import { IDocumentManagerFactory } from 'app/services/rtc/sync/DocumentSpec';
import { IEncodedCallStateAction } from '@engoo/realtime-protocol/callState';
import { IDocumentManagerState } from 'app/containers/rtc/DocumentProvider/useDocumentManager';

type CallStateManager = LWWDocumentManager<CallState, IEncodedCallStateAction>;

export type CallStateDocumentManagerState = IDocumentManagerState<CallState, CallStateManager>;

const managerType: IDocumentManagerFactory<
  CallState,
  IEncodedCallStateAction,
  IActionHandler<CallState, IEncodedCallStateAction>,
  CallStateManager
> = LWWDocumentManager;

const actionHandler: IActionHandler<CallState, IEncodedCallStateAction> = { apply: callStateReducer };

export const CallStateDocumentSpec = {
  managerType,
  actionHandler,
  initialState:  callStateReducer(),
  name: (t: tFunctionType) => t('rtc.features.call-state.name'),
};

export default {
  [Stream.CallState]: CallStateDocumentSpec,
};
